
import { Chart as ChartJS, defaults, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';

import { Bar, Pie } from 'react-chartjs-2';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend
// );

ChartJS.register(ArcElement, Tooltip, Legend);

defaults.maintainAspectRatio = false;
defaults.responsive = true;

const CallSummaryChart = ({ data = {} }) => {
    // const data = {
    //     labels: ['Category A', 'Category B', 'Category C'],
    //     datasets: [
    //         {
    //             label: 'Subcategory 1',
    //             data: [10, 15, 7],
    //             backgroundColor: 'rgba(255, 99, 132, 0.5)',
    //         },
    //         {
    //             label: 'Subcategory 2',
    //             data: [8, 12, 10],
    //             backgroundColor: 'rgba(53, 162, 235, 0.5)',
    //         },
    //     ],
    // };
    console.log(data)
    return <Pie
        data={data}
    // data={{
    //     labels: ['claims', 'benefits', 'provider'],
    //     datasets: [
    //         {
    //             label: 'counts',
    //             data: [200, 300, 100],
    //             backgroundColor: [
    //                 `rgba(249, 202, 83, 0.8)`,
    //                 `rgba(66, 132, 247, 0.8)`,
    //                 `rgba(247, 171, 66, 0.8)`
    //             ],
    //             borderRadius: 5
    //         }
    //     ]
    // }}
    // options={{
    //     responsive: true,
    //     plugins: {
    //         legend: {
    //             //  position: 'top',
    //             display: false
    //         },
    //         title: {
    //             display: false,
    //             text: 'Category and Subcategory Data',
    //         },

    //     },
    // }}
    />;
};

export default CallSummaryChart;